import gql from 'graphql-tag';

export const departmentWeatherQuery = gql`
  query departmentWeather($id: ID!) {
    departmentWeather(id: $id)
  }
`;
